import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { WhyBuildSection } from '../components/WhyBuildSection';
import { Top10Section } from '../components/Top10Section';
import { SovereignNodesSection } from '../components/SovereignNodesSection';
import { Top20Section } from '../components/Top20Section';
import { OpenProposalsSection } from '../components/OpenProposalsSection';
import { Footer } from '../components/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#000000]" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <WhyBuildSection />
      <Top10Section />
      <SovereignNodesSection />
      <Top20Section />
      <OpenProposalsSection />
      <Footer />
    </div>
  );
}
